import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Button from '../Buttons/ButtonAction';
import ComboText from '../ComboText';
import { FormControl, InputLabel, Select, MenuItem, Container, ListItemText } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { ESTADOSITEMS, ESPECIALIDADITEMS, SPECIALITIESANDSUBS } from '../../utils/ConstantsMain';
import { SPEANDSUB, getSpecialityWithSub } from '../../utils/SubSpecialties';
import { changeTab } from '../../store/actions/LaywerUserAction';
import { connect } from 'react-redux';
import './Searcher.scss';

const useStyles = makeStyles(theme => ({
  heightSelect: {
    maxWidth: 920,
  },
  textField: {
    backgroundColor: 'white',
    margin: 0,
    padding: 0,
    height: 48,
    minWidth: '100%',
    marginRight: theme.spacing(1),
    '@media (max-width: 1250px)': {
      width: '100%',
      marginBottom: 6,
      maxWidth: 920,
    },
    '@media (max-width: 460px)': {
      minWidth: 'unset',
    },
  },
  comboText1: {
    minWidth: 360,
    marginRight: theme.spacing(1),
    '@media (max-width: 1250px)': {
      width: '100%',
      marginBottom: 6,
      maxWidth: 920,
    },
    '@media (max-width: 768.98px)': {
      backgroundColor: 'rgba(209, 216, 222, 0.6)',
      padding: 8,
      borderRadius: 4,
    },
    '@media (max-width: 460px)': {
      minWidth: 'unset',
    },
  },
  comboText2: {
    minWidth: 360,
    marginRight: theme.spacing(1),
    '@media (max-width: 1250px)': {
      width: '100%',
      marginBottom: 6,
      maxWidth: 920,
    },
    '@media (max-width: 768.98px)': {
      backgroundColor: 'rgba(209, 216, 222, 0.6)',
      padding: 8,
      borderRadius: 4,
      margin: '0 8px 10px 0'
    },
    '@media (max-width: 460px)': {
      minWidth: 'unset',
    },
  },
  autocomplete: {
    '@media (max-width: 768.98px)': {
      margin: 0,
      padding: 0,
      borderRadius: 4,
    },
  },
  select: {
    width: 360,
    marginRight: 8,
  },
  buttonContainer: {
    '@media (max-width: 798.98px)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  button: {
    width: 152,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1250px)': {
      width: '100%',
    },
    '@media (max-width: 798.98px)': {
      width: '94%',
    },
  },
  subSpeciality: {
    padding: '0 0 0 50px',
    whiteSpace: 'inherit',
  },
  speciality: {
    color: '#013957',
  },
  formControl: {
    maxWidth: 'inherit',
    height: 40,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: '10px',
    top: '-3px',
  },
  inputLabelShrink: {
    transform: 'translate(14px, -3px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: 'aliceblue',
    height: 'fit-content',
  },
  paper: {
    minWidth: 360,
    padding: 0,
    width: 354,
    '@media (max-width: 798.98px)': {
      minWidth: 'inherit',
      width: 'inherit',
    }
  }
}));

const Searcher = (props) => {

  const [specialty, setSpecialty] = useState('')
  const [subSpeciality, setSubSpeciality] = useState('')
  const [stateSite, setStateSite] = useState('')
  const history = useHistory();
  const classes = useStyles();

  const handleSetSpecialty = field => value => {
    if (ESPECIALIDADITEMS.includes(value)) {
      setSpecialty(value)
      setSubSpeciality('')
    } else if (SPECIALITIESANDSUBS.includes(value)) {
      const spe = getSpecialityWithSub(value)
      setSpecialty(spe)
      setSubSpeciality(value)
    } else {
      setSpecialty('')
      setSubSpeciality('')
    }
  };

  const handleSetState = field => value => {
    setStateSite(value)
  };



  const handleSearch = () => {
    props.changeTab(0)
    if (specialty && subSpeciality && stateSite) {
      history.push(`/busqueda/especialidad/${specialty}/${subSpeciality}/${stateSite}`);
    } else if (specialty && stateSite) {
      history.push(`/busqueda/estado/${stateSite}/${specialty}`);
    } else if(specialty && subSpeciality){
      history.push(`/busqueda/especialidad/${specialty}/${subSpeciality}`);
    } else if(specialty){
      history.push(`/busqueda/especialidad/${specialty}`);
    } else if(stateSite){
      history.push(`/busqueda/estado/${stateSite}`);
    } else {
      history.push('/busqueda')
    }
  }

  return (
    <div>
      <div className="searcher">
        <div className={classes.comboText1}>
          <ComboText
            labelText={'Especialidades / Asuntos legales'}
            itemsCombo={SPECIALITIESANDSUBS}
            handleChanges={handleSetSpecialty('specialties')}
            textFieldStyles={classes.autocomplete}
            name={'specialties'}
            inSearcher
          />
        </div>
        <div className={classes.comboText2}>
          <ComboText
            labelText={'Estado'}
            itemsCombo={ESTADOSITEMS}
            handleChanges={handleSetState('states')}
            textFieldStyles={classes.autocomplete}
            name={'states'}
            inSearcher
          />
        </div>
        <div className={classes.buttonContainer} onClick={handleSearch}>
          <Button
            variant="extra"
            className={classes.button}
          >
            <img
              src="/img/LandingClient/search.svg"
              alt="buscar"
              style={{ marginRight: 16 }}
            />
            Buscar
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  changeTab: tab => dispatch(changeTab(tab))
})

export default connect(null, mapDispatchToProps)(Searcher);
